module.exports = __webpack_public_path__ + "static/media/me.d49d40cb.jpg";